<template>
	<section class="view-venue-friendlyfaces padded dark-panel">
		<ViewLayoutModuleHeader title="Friendly faces">
			<a href="#" v-on:click="Handle_OnClickViewAll">View All</a>
		</ViewLayoutModuleHeader>

		<!-- Gallery of media -->
		<section>
			<ChalkyMediaVenue
				v-bind:tagged="true"
				v-bind:venueModel="venueModel"
				v-on:click:menu="Handle_OnClickMediaMenu"
				v-on:click:user="Handle_OnClickUser"
				v-on:select="Handle_OnSelectMediaGalleryItem"
			>
				<template v-slot:empty="{ venueModel }">
					<ViewUiCalloutMedia
						action="Take a Photo"
						subtitle="Snap a photo with your friends and get featured on the wall."
						title="Get on the wall"
						v-bind:imageUrl="$asset('image/graphic/cartoon-friends-00.webp')"
						v-bind:venueModel="venueModel"
						v-if="$feature('venue_friendlyfaces_ugc')"
						v-on:action="Handle_OnClickAction"
					/>
				</template>
			</ChalkyMediaVenue>
		</section>

		<!-- Call to action under the main board -->
		<ViewUiCalloutAction
			subtitle="If this is your local haunt, submit a photo to represent. Keep it classy."
			title="Want to be on the board?"
			v-if="$feature('venue_friendlyfaces_ugc')"
			v-on:action="Handle_OnClickAction"
		/>

		<!-- Gallery (popup) -->
		<ChalkyUtilityModal
			class="default-modal"
			v-bind:closeOnBackdropClick="true"
			v-bind:closeOnEscape="true"
			v-bind:showCloseButton="true"
			v-model="showGalleryModal"
		>
			<ViewVenueCommunityGallery
				v-bind:key="venueModel.taggedMedia.uniqueKey"
				v-bind:venueModel="venueModel"
				v-on:select="Handle_OnSelectMediaGalleryItem"
			/>
		</ChalkyUtilityModal>

		<!-- Context menu for image actions -->
		<!-- <ChalkyModalActionMenu v-if="showActionMenu" v-model="showActionMenu">
			<button class="button-secondary" v-on:click="Handle_OnClickActionMenuOption('gallery')">
				View Gallery
			</button>
			<button class="button-secondary" v-on:click="Handle_OnClickActionMenuOption('report')">Report Image</button>
		</ChalkyModalActionMenu> -->
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * Displays a slideshow of friendly faces (media) associated with a venue.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Venue
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewVenueFriendlyFaces extends ViewBase {
		/**
		 * @return ChalkySticks.Model.User
		 */
		public get userModel(): ChalkySticks.Model.User {
			return this.$store.getters['authentication/user'];
		}

		/**
		 * The venue model containing media data
		 *
		 * @type ChalkySticks.Model.Venue
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Venue.model(),
		})
		public venueModel!: ChalkySticks.Model.Venue;

		/**
		 * Whether to show the action menu
		 *
		 * @type boolean
		 */
		protected showActionMenu: boolean = false;

		/**
		 * Whether the gallery modal is visible
		 *
		 * @type boolean
		 */
		protected showGalleryModal: boolean = false;

		/**
		 * Navigates to the place gallery page
		 *
		 * @return void
		 */
		protected viewGallery(): void {
			this.showGalleryModal = true;
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param ChalkySticks.Model.Media mediaModel
		 * @return Promise<void>
		 */
		protected async Handle_OnClickMediaMenu(mediaModel: ChalkySticks.Model.Media): Promise<void> {
			this.showActionMenu = true;
		}

		/**
		 * @return Promise<void>
		 */
		protected async Handle_OnClickAction(): Promise<void> {
			this.$emit('submit:media');
		}

		/**
		 * @param ChalkySticks.Model.User userModel
		 * @return Promise<void>
		 */
		protected async Handle_OnClickUser(userModel: ChalkySticks.Model.User): Promise<void> {
			this.$store.dispatch('gotoUser', userModel);
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickViewAll(e: PointerEvent): Promise<void> {
			e.preventDefault();
			e.stopPropagation();

			this.viewGallery();
		}

		/**
		 * @param ChalkySticks.Model.Media mediaModel
		 * @return Promise<void>
		 */
		protected async Handle_OnSelectMediaGalleryItem(mediaModel: ChalkySticks.Model.Media): Promise<void> {
			this.$router.push({
				name: 'PagePlaceGalleryItem',
				params: {
					id: this.venueModel.id,
					mediaId: mediaModel.id,
				},
			});
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-venue-friendlyfaces {
		.chalky.media-venue {
			figcaption {
				background: var(--chalky-blue-4);
			}

			.chalky.user-attribution {
				background-color: var(--chalky-blue-4);
				backdrop-filter: none;
				padding: 0;
			}
		}

		.utility-modal.default-modal .modal-content {
			padding: 0;

			.utility-gallery {
				height: 100%;
				overflow: auto;
			}
		}

		.media-container.media-container-empty {
			background-color: var(--chalky-blue-4);
		}

		.utility-gallery.grid .gallery-item {
			aspect-ratio: 1 / 1;
		}

		.utility-pagination {
			flex: 0 0 auto !important;
			justify-content: center;
		}
	}

	// State
	// ---------------------------------------------------------------------------

	.view-venue-friendlyfaces {
		.chalky.media-feed.aspect-portrait.is-empty {
			aspect-ratio: auto;
		}
	}
</style>
